/* global window */

export function isEmbeddableCrossOriginIframe() {
  if (typeof window === "undefined") return false;
  if (!window.location.pathname.endsWith("/embeddable.html")) return false;
  if (window.parent === window) return false;
  try {
    return window.parent.location.origin !== window.location.origin;
  } catch {
    // Reading parent.location across origins throws — exactly the case we want.
    return true;
  }
}
